import React from 'react';
import PropTypes from 'prop-types';
import { Icon, IconButton } from '@cbrebuild/blocks';
import { Progress } from '@cbrebuild/blocks-react';

const FileUploadModalListItem = (props) => {
  const { file, onFileNameChange, onRemove } = props;
  // eslint-disable-next-line no-bitwise
  const fileName = file.fileData && file.fileData.name ? file.fileData.name : file.title;
  const fileType = fileName.slice(((fileName.lastIndexOf('.') - 1) >>> 0) + 2);
  const { title = '', uploadProgress } = file;

  return (
    <React.Fragment>
      <li>
        <div>
          <Icon iconName="document" size="x-large" />
          <div className={`doc-type-extension doc-type-${fileType}`}>
            {fileType}
          </div>
        </div>
        <div>
          <span className="attachment-name">* Attachment Name</span>
          <input
            name="title"
            onChange={e => onFileNameChange(e.target.value)}
            type="text"
            value={title}
            className="input-text"
          />
        </div>
        <div className="file-item-actions">
          <IconButton iconName="close" onClick={onRemove} variant="basic" />
        </div>
      </li>
      {!!uploadProgress && <Progress progress={uploadProgress} />}
    </React.Fragment>
  );
};

FileUploadModalListItem.propTypes = {
  file: PropTypes.shape({
    fileData: PropTypes.shape({
      lastModified: PropTypes.number,
      lastModifiedDate: PropTypes.shape({}),
      name: PropTypes.string,
      size: PropTypes.number,
      type: PropTypes.string,
      webkitRelativePath: PropTypes.string,
    }),
    isPrivate: PropTypes.bool,
    title: PropTypes.string,
    uploadProgress: PropTypes.number,
  }).isRequired,
  onFileNameChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default FileUploadModalListItem;
